import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import statusReducer from "./status/reducer";
import profileReducer from "./profile/reducer";
import authReducer from "./authentication/reducer";
import complaintsReducer from "./complaints/reducer";
import proceduresReducer from "./procedures/reducer";
import locationsReducer from "./locations/reducer";
import faceComparisonReducer from "./faceComparison/reducer";

const authPersistConfig = {
  key: "auth",
  storage: storage,
  blacklist: ["loading", "credentials"]
};

const faceComparisonPersistConfig = {
  key: "faceComparison",
  storage: storage,
  blacklist: ["loading", "data", "offlineRequests", "captures"]
};

const profilePersistConfig = {
  key: "profile",
  storage: storage,
  blacklist: ["loading"]
};

const statusPersistConfig = {
  key: "status",
  storage: storage,
  blacklist: ["code", "message"]
};

const complaintsPersistConfig = {
  key: "complaints",
  storage: storage,
  blacklist: ["loading", "data", "totalCount"]
};

const proceduresPersistConfig = {
  key: "procedures",
  storage: storage,
  blacklist: ["loading"]
};

const locationsPersistConfig = {
  key: "locations",
  storage: storage,
  blacklist: ["loading"]
};

const rootPersistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["auth", "profile", "status", "faceComparison", "complaints", "procedures", "locations"]
};

//root reducer
const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  complaints: persistReducer(complaintsPersistConfig, complaintsReducer),
  faceComparison: persistReducer(
    faceComparisonPersistConfig,
    faceComparisonReducer
  ),
  profile: persistReducer(profilePersistConfig, profileReducer),
  status: persistReducer(statusPersistConfig, statusReducer),
  procedures: persistReducer(proceduresPersistConfig, proceduresReducer),
  locations: persistReducer(locationsPersistConfig, locationsReducer)
});

export const persistedReducer = persistReducer(rootPersistConfig, rootReducer);
